import script from "./expertConsultant-list.vue?vue&type=script&setup=true&lang=js"
export * from "./expertConsultant-list.vue?vue&type=script&setup=true&lang=js"

import "./expertConsultant-list.vue?vue&type=style&index=0&id=75bcd245&scoped=true&lang=scss"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75bcd245"]])

export default __exports__